// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2duiD","select":"Header_select__1ywm4","clinic":"Header_clinic__3-HyB"};